<div
  [formGroup]="form"
  class="form-group checkbox-form-group app-checkbox-container"
>
  <div *ngIf="field.label">
    <label class="parent-label">
      {{ field.label }}{{ field.validation?.required ? '*' : '' }}
    </label>
    <app-info-icon
      [message]="field.infoIconMessage"
      *ngIf="field.infoIconMessage"
    ></app-info-icon>
  </div>
  <div
    class="cb-option-container"
    [ngClass]="
      !field.optionDirection
        ? 'cb-option-container'
        : 'cb-vertical-option-container'
    "
  >
    <label
      *ngFor="let option of field.options"
      class="custom-checkbox d-flex"
      [ngClass]="{
       
        'disabled-label': !!option.disabled
      }"
      [ngStyle]="
        !field.optionDirection
          ? { width: 'calc(100% / ' + field.options.length + ')' }
          : {}
      "
    >
      <span
        class="option-label"
        [title]="option[field.labelKey]"
        *ngIf="field.optionDirection === optionDirectionEnum.VERTICAL"
      >
        {{ option[field.labelKey] }}
      </span>
      <input
        type="checkbox"
        [checked]="isChecked(option)"
        [disabled]="option.disabled || false"
        ([ngModel])="(option.isChecked)"
        (change)="onCheckboxChange(option, $event)"
        (click)="onCheckboxClick($event, option)"
      />
      <span
        class="checkmark checkmark-md rounded"
        [ngClass]="{
          'checkmark-vertical':
            field.optionDirection === optionDirectionEnum.VERTICAL,
          'checkbox-dummy-disabled': option.checkedValueNotAllowed,
          'disabled-checkbox': !!option.disabled,
          'icon-liteicon-black-tick': isChecked(option) && !option.checkedValueNotAllowed
        }"
      ></span>
      <span
        class="option-label"
        [title]="option[field.labelKey]"
        *ngIf="field.optionDirection !== optionDirectionEnum.VERTICAL"
      >
        {{ option[field.labelKey] }}
      </span>
      <app-info-icon
        [cls]="field.infoIconMessageCls"
        [message]="field.infoIconMessageLbl"
        *ngIf="field.infoIconMessageLbl"
      ></app-info-icon>
    </label>
    <div *ngIf="!field.options?.length">
      <span class="empty-option-msg">{{  (filterDropdownValues.value?.length && field.emptyOptionMessageFiltered) ? field.emptyOptionMessageFiltered : field.emptyOptionMessage }}</span>
    </div>
  </div>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
